import { apiGet, getApiUrl } from "Infrastructure/Api/Api";
import type { ProtocolRecord } from "Order/Modules/MorningCheck/Api/Query/useOrderProtocolsQuery";
import { useQuery } from "@tanstack/react-query";

export const ALL_PROTOCOLS_KEY = "ALL_PROTOCOLS";

const PAGE_SIZE = 50;

export type ProtocolTypeFilter = "start" | "handover" | "";
export type ProtocolStatusFilter =
	| "draft"
	| "sent"
	| "accepted"
	| "declined"
	| "";

export interface ProtocolsFilters {
	type: ProtocolTypeFilter;
	status: ProtocolStatusFilter;
}

interface ProtocolsResponse {
	records: ProtocolRecord[];
	totalCount: number;
	pageSize: number;
}

export const useAllProtocolsQuery = (page: number, filters: ProtocolsFilters) =>
	useQuery({
		queryKey: [ALL_PROTOCOLS_KEY, page, filters],
		queryFn: async (): Promise<ProtocolsResponse> => {
			const params = new URLSearchParams();
			params.set("page", String(page));
			params.set("limit", String(PAGE_SIZE));
			if (filters.type) params.set("type", filters.type);
			if (filters.status) params.set("status", filters.status);
			const response = await apiGet(
				`${getApiUrl()}/protocols?${params.toString()}`,
				new Headers(),
				{},
			);
			if (response.status >= 400) throw new Error("Failed to fetch protocols");
			return response.data as ProtocolsResponse;
		},
		refetchInterval: 30_000,
	});
